import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { LucideAngularModule } from "lucide-angular";
import { ChangeMemberRoleDialogComponent } from "./change-member-role-dialog.component";

@NgModule({
  declarations: [ChangeMemberRoleDialogComponent],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, LucideAngularModule],
})
export class ChangeMemberRoleDialogModule {}
